import { addTokensToLocalStorage, getUserDetails, refreshAccessToken, getAccessToken } from "../../helper/utils";

const toDigits = (value = "") => value.replace(/\D/g, "");
const toIndianLocalDigits = (value = "") => {
  const digits = toDigits(value);
  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);
  return digits.length > 10 ? digits.slice(-10) : digits;
};
const toIndianE164 = (value = "") => `+91${toIndianLocalDigits(value)}`;

const requestJson = async (url, options) => {
  const response = await fetch(url, { credentials: "include", ...options });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(data?.message || data?.errorMessage || "Something went wrong");
    error.status = response.status;
    throw error;
  }
  return { response, data };
};

export const normalizeIdentifier = (identifier = "") => {
  const value = identifier.trim();
  return value.includes("@") ? value.toLowerCase() : toIndianE164(value);
};

export const createSubscriptionSession = async ({ accessToken, refreshToken }) => {
  if (!accessToken || !refreshToken) throw new Error("Session missing");
  addTokensToLocalStorage(accessToken, refreshToken);
  const user = await getUserDetails();
  if (!user || user?.status === 401) throw new Error("Details missing");
  window.localStorage.setItem("user", JSON.stringify(user));
  return user;
};

export const requestAccessTypeToken = async (ssoEndpoint) => {
  const accessToken = getAccessToken();
  const headers = { "Content-Type": "application/json" };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  const url = ssoEndpoint ? `${ssoEndpoint}/auth/accesstype-pv-token` : "/auth/accesstype-pv-token";
  
  let response, data;
  try {
    const res = await requestJson(url, { method: "POST", headers });
    response = res.response;
    data = res.data;
  } catch (error) {
    if (error.status === 401) {
      console.log("[Auth] accesstype-pv-token returned 401. Triggering token refresh retry...");
      const result = await refreshAccessToken(() => requestAccessTypeToken(ssoEndpoint));
      if (result?.status === 401 || result instanceof Error) {
        throw new Error("Session refresh failed");
      }
      return result;
    }
    throw error;
  }

  const token =
    data?.token ||
    data?.jwt ||
    data?.accesstypeJwt ||
    data?.accessTypeToken ||
    response.headers.get("x-integration-token") ||
    response.headers.get("authorization");

  if (!token) throw new Error("AccessType JWT missing from response.");
  return String(token).replace(/^Bearer\s+/i, "");
};
